import { getTasks } from '../../api';
import { useListFetch } from '../../hooks';
import type { TaskResponse, GetTasksPayload } from '../../api';

export const useTasks = () => {
  return useListFetch<TaskResponse, GetTasksPayload['filters']>(
    async params => {
      const result = await getTasks({
        filters: params?.filters || {},
        page: params?.pagination,
      });

      return { content: result };
    },
    {
      initialPageSize: 1_000,
      initialFilters: { campaignId: '', status: '' },
      withQueryParams: true,
    }
  );
};

export type ItemType = TaskResponse;
